export default __webpack_public_path__ + "media/images/features/local_delivery/ttl1-cbef43af5454cba452c4a3a7c69c8661.png";